export default __webpack_public_path__ + "media/welcome-back-offer.e61bd4b59c38191c90762cfb393ef6c5.gif";